import type { MaskTokens } from '../types'
import maskit from './maskit'
import dynamicMask from './dynamic-mask'

// Facade to maskit/dynamicMask when mask is String or Array
const masker = (
  value: string,
  mask: Array<string> | string,
  masked = true,
  tokens: MaskTokens,
  caretPosition: number,
) => Array.isArray(mask)
  ? dynamicMask(maskit, mask, tokens)(value, mask, masked, caretPosition)
  : maskit(value, mask, masked, tokens, caretPosition)

export default masker
